import React from "react";
import styled from "styled-components";
import Loading from "common/Loading";
import { parseStatsRtxData } from "views/Statistics/System/StatsRtx/api";
import { NVLineChartDownsampled } from "common/graphs/DownSampling";
import * as d3 from "d3";
import { PERIOD_DASHBOARD_PERIOD_MAP } from "./utils";
import useDashboardData from "./useDashboardData";
import { PERIOD_TO_LINES } from "common/constants";
import { atBqnTarget } from "common/api";

// The chart draws one field, so it is the same list every time.
const RTX_FIELDS = [{ name: "Rtx%-Access", label: "Rtx%-Access" }];

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
`;

const WrapperLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 180px;
  color: var(--text-primary);
`;

const getRetransmissionsData = ({ mode, bqnId, period, range }) => {
  const periodRtx = PERIOD_DASHBOARD_PERIOD_MAP[period];
  const { from, to } = range;
  return ifCl
    .run(
      atBqnTarget(
        `show statistics retransmission lines ${PERIOD_TO_LINES[periodRtx]}`,
        mode,
        bqnId
      )
    )
    .then((response) => ({
      data: parseStatsRtxData(response, periodRtx, from, to),
      range,
    }));
};

function Retransmissions({ period, range }) {
  // The range of the dashboard is the clock of the chart, which is asked for
  // again with each new one of them.
  const { data: dataRange, isLoading } = useDashboardData({
    retrieve: ({ mode, bqnId, range }) =>
      getRetransmissionsData({ mode, bqnId, period, range }),
    onError: "Error fetching retransmissions data:",
    deps: [period],
    range,
  });

  if (isLoading) {
    return (
      <WrapperLoader>
        <Loading />
      </WrapperLoader>
    );
  }

  if (!dataRange || !dataRange.data || !dataRange.data.items || dataRange.data.items.length === 0) {
     return (
      <WrapperLoader>
        No data available
      </WrapperLoader>
    );
  }

  const { data, range: rangeDrawn } = dataRange;
  const { items } = data;

  return (
    <Wrapper>
      <NVLineChartDownsampled
        key="rtx-over-time"
        xField="time"
        items={items}
        range={rangeDrawn}
        yAxisUnits={"%"}
        yAxisFormat={d3.format(".1f")}
        xAxisFormat={d3.timeFormat("%m/%d %H:%M")}
        fields={RTX_FIELDS}
        yAxisTopGap={0.05}
        yAxisTicksNumber={4}
        xAxisTicksNumber={4}
        yTooltipFormat={(d) => d3.format(".2f")(d) + " %"}
        fixedYRange={[0, 1]}
        margin={{ top: 5, right: 10, bottom: 20, left: 60 }}
      />
    </Wrapper>
  );
}

export default React.memo(Retransmissions);
